<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Widgets" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->



<div class="row">
  <div class="col-xl-3 col-md-6" *ngFor="let data of tileBoxs3">
      <div class="card card-animate" [ngClass]=" { 'bg-primary': data.bgColor}">
          <div class="card-body">
              <div class="d-flex justify-content-between">
                  <div>
                      <p class="fw-medium text-{{data.labelClass}} mb-0">{{data.label}}</p>
                      <h2 class="mt-4 ff-secondary fw-semibold" [ngClass]=" { 'text-white': data.counterClass}"><span *ngFor="let user of data.subCounter"><span [CountTo]="user.counter" class="counter-value" [from]="0" [duration]="user.decimals"></span>{{user.suffix}}</span></h2>
                      <p class="mb-0 text-{{data.labelClass}}"><span class="badge {{data.badgeClass}} mb-0">
                          <i class="{{data.badge}}"></i> {{data.percentage}}
                      </span> vs. previous month</p>
                  </div>
                  <div>
                      <div class="avatar-sm flex-shrink-0">
                          <span class="avatar-title bg-soft-{{data.iconClass}} rounded-circle fs-2">
                              <i-feather name="{{data.feaIcon}}" class="text-{{data.iconClass}} feather-icon-align"></i-feather>
                          </span>
                      </div>
                  </div>
              </div>
          </div><!-- end card body -->
      </div> <!-- end card-->
  </div> <!-- end col-->
</div> <!-- end row-->

